<template>
  <div class="vfl-has-label">
    <label class="vfl-label" :class="classObject" :for="inputId">
      {{ floatLabel }}
    </label>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'FloatLabel',
  props: {
    on: {
      type: Boolean,
      default: true
    },
    fixed: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    dispatch: {
      type: Boolean,
      default: true
    },
    for: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      formEl: undefined,
      labelEl: undefined,
      isActive: false,
      isFocused: false
    }
  },
  computed: {
    inputId() {
      return this.for
    },
    classObject() {
      return {
        'vfl-label-on-input': this.on && (this.isActive || this.fixed),
        'vfl-label-on-focus': this.isFocused
      }
    },
    formElType() {
      return this.formEl ? this.formEl.tagName.toLowerCase() : ''
    },
    floatLabel() {
      if (this.label) return this.label

      switch (this.formElType) {
        case 'input':
        case 'textarea':
          return this.formEl.placeholder
        case 'select':
          return this.formEl.querySelector('option[disabled][selected]')
            .innerHTML
        default:
          return ''
      }
    }
  },
  mounted() {
    this.formEl = this.$el.querySelector('input, textarea, select')
    if (this.formEl) {
      this.formEl.addEventListener('input', this.updateIsActive)
      this.formEl.addEventListener('input', this.updateIsFocused)
      this.formEl.addEventListener('blur', this.updateIsFocused)
      this.formEl.addEventListener('focus', this.updateIsFocused)
    }

    if (!this.for) {
      this.labelEl = this.$el.querySelector('label')
      if (this.labelEl) {
        this.labelEl.addEventListener('click', this.focusFormEl)
      }
    }

    this.dispatchInput()
  },
  beforeDestroy() {
    if (this.formEl) {
      this.formEl.removeEventListener('input', this.updateIsActive)
      this.formEl.removeEventListener('input', this.updateIsFocused)
      this.formEl.removeEventListener('blur', this.updateIsFocused)
      this.formEl.removeEventListener('focus', this.updateIsFocused)
    }
  },
  methods: {
    dispatchInput() {
      if (this.dispatch && this.formEl) {
        const event = document.createEvent('HTMLEvents')
        event.initEvent('input', true, false)
        this.formEl.dispatchEvent(event)
      }
    },
    focusFormEl() {
      if (this.formEl) {
        this.formEl.focus()
      }
    },
    updateIsActive(e) {
      this.isActive = e.target.value.length > 0
    },
    updateIsFocused(e) {
      this.isFocused = e.target === document.activeElement && this.isActive
    }
  }
}
</script>

<style lang="scss">

@import '@/scss/abstracts/_variables.scss';

.vfl-has-label {
  position: relative;
}

.vfl-label {
  position: absolute;
  top: 0;
  overflow: hidden;
  font-size:12px;
  left: 22px;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  transition: all 0.2s ease-in-out;
  background-color:#fff;
  border-radius:50px;
  padding: 0px 7px;
}

.vfl-label-on-input {
  top: -10px;
  color:#929292;
  pointer-events: all;
  opacity: 1;
}

.vfl-label-on-focus {
  color:$color-secondary;
}

.vfl-has-label input:focus,
.vfl-has-label textarea:focus,
.vfl-has-label select:focus {
  outline: 0;
}

</style>
